import './modal.scss';
import { execOnLoad } from '@general/helpers';
import Cookies from 'js-cookie';
import { openModal } from '../../scripts/components/modals';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPopup = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const modal = sectionContainer.querySelector('.modal.modal__container');
  if (!modal) return;

  const modalTrigger = sectionContainer.querySelector('.modal__trigger a.btn');
  const modalExternalTrigger = modal.hasAttribute('data-trigger-id')
    ? modal.dataset.triggerId
    : undefined;
  const delay = parseInt(modal.dataset.delay) * 1000;
  const cookieDuration = parseInt(modal.dataset.cookieDuration);
  const id = modal.id;
  const cookie = `modal-${id}-closed`;

  modalTrigger?.addEventListener('click', (e) => {
    e.preventDefault();
    const id = modal.id;
    modal.classList.remove('modal--hidden');
    openModal(`#${id}`, false);
  });

  if (modalExternalTrigger) {
    const externalTrigger = document.getElementById(modalExternalTrigger);
    if (externalTrigger) {
      externalTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        const id = modal.id;
        modal.classList.remove('modal--hidden');
        openModal(`#${id}`, false);

        if (modalExternalTrigger == 'footerNewsletterSubmit') {
          const emailValue = document.querySelector(
            'input[name="footer-c__newsletter-email"]',
          ).value;

          if (emailValue.length > 0) {
            document.querySelector('#NewsletterEmail').value = emailValue;
          }
        }
      });
    }
  }

  if (modal.dataset.delay) {
    setTimeout(() => {
      if (Cookies.get(cookie) !== 'true') {
        openModal(`#${id}`, false);
      } else {
        modal.classList.add('modal--hidden');
      }
    }, delay);
  }

  modal
    .querySelectorAll('.modal__backdrop, .modal__close, .modal__refuse')
    .forEach((closer) =>
      closer.addEventListener('click', () => {
        if (modal.dataset.delay) {
          Cookies.set(cookie, 'true', { expires: cookieDuration });
        }
        modal.classList.add('modal--hidden');
      }),
    );
};

execOnLoad(window.dAgency.initPopup, '.popup__section');
